import {Fragment} from "react";
import {isLoginPage} from "../utility/common";

export default function Footer() {

    return (
        <Fragment>
            {
                !isLoginPage() &&
                <footer className="ns-footer mt-auto py-1 fixed-bottom">
                    <div className="container-fluid text-center">
                        <span>© YEP All rights reserved. Powered by Netsurf and Message</span>
                    </div>
                </footer>
            }
        </Fragment>
    );
}
